angular.module('cfn').factory('greeningService', greeningService);

function greeningService() {
  var numberOfCultures = function(planning) {
      return planning.plannedCultures.length;
    },
    createRuleResult = function(ruleName, success) {
      return {
        name: ruleName,
        success: success
      };
    },
    ruleWasSuccessful = function(rule) {
      return rule.success === true;
    },
    isMainCrop = function(plannedCulture) {
      return plannedCulture.sowingType === 'MAIN_CROP';
    },
    /**
     * Checks if the given crop planning satisifes greening rules
     * Expects an object in format
     * {
     * 	totalFieldArea: 42,
     *  plannedCultures: [{ sowingType: 'MAIN_CROP', plannedArea: 40 }, ...]
     * }
     *
     * Cultures have to be aggregated, i.e. if a culture is planned on different fieldsas the same crop type, it must appear only
     * once.
     *
     * Returns an object in format
     * {
     * 	success: false,
     *  rules: [{ name: 'fe.greening.rule1', success: false}, ...]
     * }
     * where the outer success is true if all rules have a success of true.
     */
    checkGreeningRules = function(planning) {
      var rules = [];

      if (planning.totalFieldArea >= 30) {
        rules.push(
          createRuleResult(
            'fe.planning.cropsequenceplanning.greening.30ha3cultures',
            numberOfCultures(planning) >= 3
          )
        );
      } else if (planning.totalFieldArea >= 10) {
        rules.push(
          createRuleResult(
            'fe.planning.cropsequenceplanning.greening.10ha2cultures',
            numberOfCultures(planning) >= 2
          )
        );
      }

      if (planning.totalFieldArea > 0) {
        // A main crop must not take more than 75% of the crop area
        rules.push(
          createRuleResult(
            'fe.planning.cropsequenceplanning.greening.mainCropMax75percent',
            !planning.plannedCultures.some(function(plannedCulture) {
              return (
                plannedCulture.sowingType === 'MAIN_CROP' &&
                plannedCulture.plannedArea / planning.totalFieldArea > 0.75
              );
            })
          )
        );

        // Two main crops must not take more than 95% of the crop area
        rules.push(
          createRuleResult(
            'fe.planning.cropsequenceplanning.greening.twoMainCropsMax95percent',
            // Check that there is no culture that combines with another culture to over 95%
            !planning.plannedCultures.some(function(culture1, idx1) {
              return (
                isMainCrop(culture1) &&
                // Culture alone has more than 95%
                (culture1.plannedArea / planning.totalFieldArea > 0.95 ||
                  // or culture in combination with any other main crop culture has more than 95%
                  planning.plannedCultures.some(function(culture2, idx2) {
                    return (
                      idx1 !== idx2 &&
                      isMainCrop(culture2) &&
                      (culture1.plannedArea + culture2.plannedArea) /
                        planning.totalFieldArea >
                        0.95
                    );
                  }))
              );
            })
          )
        );
      }

      return {
        success: rules.every(ruleWasSuccessful),
        rules: rules
      };
    };

  return {
    checkGreeningRules: checkGreeningRules
  };
}

export default greeningService;
